import React from 'react';
import { sum } from '@finect/front-utils/sum';
import { getSRRIByValue, getSRRIByName } from '@finect/front-resources/RiskProfile';
import { Badge } from './partials';
export var RiskProfileUserHint = function RiskProfileUserHint(_ref) {
  var product = _ref.product,
    user = _ref.user,
    onAction = _ref.onAction;
  var risk = user.isLoggedIn && user.risk && user.risk.valoration ? user.risk : null;
  if (!risk) {
    return React.createElement(Badge, {
      type: "equal",
      onClick: onAction
    }, "Averigua el tuyo");
  }
  var productRiskProfile = getSRRIByValue(product.entity.srri);
  var userRiskProfile = getSRRIByName(risk.valoration);
  if (!productRiskProfile || !userRiskProfile) {
    return null;
  }
  var productLevel = sum(productRiskProfile.value);
  var userLevel = sum(userRiskProfile.value);
  if (productLevel < userLevel) {
    return React.createElement(Badge, {
      type: "lower"
    }, "Menos que t\xFA");
  }
  if (productLevel > userLevel) {
    return React.createElement(Badge, {
      type: "higher"
    }, "M\xE1s que t\xFA");
  }
  return React.createElement(Badge, {
    type: "equal"
  }, "Igual que t\xFA");
};